import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;

import { Box, Button, FormField, RadioGroup, Select, SelectProps, SpaceBetween, SplitPanel } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { addDays, format, subMonths } from 'date-fns';
import CurrencyInput from '../../../../../components/CurrencyInput';
import Favorites from '../../../../../components/extras/Favorites';
import HorizontalRule from '../../../../../components/HorizontalRule';
import SelectUser from '../../../../../components/selects/selectUser';
import TableFlights from '../../../../../components/tables/tableFlights';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemFlight, ItemsMovement } from '../../../../../resources/types';
import {
    addNotification, addNotificationStatus, buildBreadcrumbItems, formatCurrency,
    getCookie,
    getUrlVersion, getUser,
    setData,
    setLoading
} from '../../../../commons/functions';



const pageSize = 10;
type OptionDefinition = SelectProps.Option;

type ItemFrequent = {
    id: string;
    text: string;
};
type ItemEquipment = {
    idEquipment: number;
    registration: string;
};
type ItemVoucher = {
    label: string;
    value: string;
    description?: string;
    idMovement?: number;
    tags?: string[];
    labelTag?: string;
}
export const OPSFlightsInvoice = () => {
    const { data, menu, parameters } = useGlobalState();
    const [costValue, setCostValue] = useState("");
    const [filteringText, setFilteringText] = useState("");



    const [flight, setFlight] = useState<ItemFlight>();
    const [flights, setFlights] = useState<ItemFlight[]>([]);
    const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const [movement, setMovement] = useState<ItemVoucher>();
    const [flightsSearch, setFlightsSearch] = useState<ItemFlight[]>([]);
    const [flightsInvoice, setFlightsInvoice] = useState<ItemFlight[]>([]);
    const [flightInvoice, setFlightInvoice] = useState<ItemFlight>();



    const [costOther, setCostOther] = useState("0");
    const [chargeIdUser, setChargeIdUser] = useState(0);
    const [chargeCost, setChargeCost] = useState(0);
    const [chargeValid, setChargeValid] = useState(true);

    const mountedRef = useRef(false);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {
                if (!mountedRef.current) {
                    mountedRef.current = true;
                    refreshInvoice()
                }
                setFlightInvoice(undefined)
                handleGetInvoice(parseInt(id))
            } else {
                setMovement(undefined)
                setFlightInvoice(undefined)
                refreshInvoice();
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);




    useEffect(() => {
        setChargeValid(false)
        if (chargeIdUser === 0) setChargeValid(true)
        if (costValue === "") setChargeValid(true)
        if (costValue === "costOther" && costOther === "") {
            setChargeValid(true)
        }
    }, [chargeIdUser, costValue, costOther]);


    const isValidCost = () => {
        if (!flightInvoice) return false;
        if (flightInvoice.idUserCost === -2 || flightInvoice.costReal === -2) return false;
        let isValid = true;
        if (flightInvoice.idUserCost === 0 && chargeIdUser === 0) {
            isValid = false
        }
        if (flightInvoice.costReal === -1 && chargeCost === 0) {
            isValid = false;
        }

        return isValid
    }
    console.log(isValidCost())


    const handleGetInvoice = async (id: number) => {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/flight',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    columns: "idFlight, idTowingTo, idUserPilot, idUserCost, idUserInstructor, userPilot, userInstructor, userCost, cost, costReal, departureDate, arrivalDate, delta, timeCount, registration, isClosed, altitude, idFlightType",
                    idFlight: id,
                    isInvoice: 1,
                    isInvoiced: 0,
                    isClosed: 0,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            addNotificationStatus(dataWeb, setData);
            if (dataWeb.code == 0) {// Map the data to sync the fields
                console.log(dataWeb.flight)
                let mappedFlight = {
                    ...dataWeb.flight, // <--- You need a comma here
                    loading: false,
                    idUserCost: dataWeb.flight.idFlightType !== 4720 ? -2 : 6559, // dataWeb.flight.idUserPilot,
                    costReal: -2, //dataWeb.flight.cost
                };
                console.log(mappedFlight)
                setFlightInvoice(mappedFlight);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    const refreshInvoice = async () => {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                timeout: 30000,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    columns: "idFlight, idTowingTo, idUserPilot, idUserCost, idUserInstructor, userPilot, userInstructor, userCost, cost, costReal, departureDate, arrivalDate, delta, timeCount, registration, isClosed, altitude, idFlightType, groupTypeMasterCode",
                    isInvoice: 1,
                    isInvoiced: 0,
                    isClosed: 0,
                    startDate: format(subMonths(new Date(), 2), 'dd-MM-yyyy'),
                    endDate: format(addDays(new Date(), 1), 'dd-MM-yyyy'),
                    orderBy: "departureDate",
                    order: "desc",
                    orderBy2: "idTowingTo",
                    order2: "asc"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {// Map the data to sync the fields
                const mappedFlights = data.flights.map((flight: ItemFlight) => ({
                    ...flight,
                    loading: false,
                    idUserCost: flight.idFlightType === 4720 ? 6559 : 0,
                }));
                setFlightsInvoice(mappedFlights);
                refreshMovements()
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const refreshMovements = async () => {

        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    columns: "idMovement, ammount, dateTransaction, jsonMovement, receipt, data",
                    voucherStage: 2,
                    start: format(subMonths(new Date(), -12), 'dd-MM-yyyy'),
                    orderBy: "dateTransaction",
                    order: "desc",
                    orderBy2: "idMovement",
                    order2: "desc"
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {// Map the data to sync the fields
                setMovements(data.movements);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleInvoice = async (flight: ItemFlight) => {
        try {
            setLoading(true)
            let flightInvoiceUpdated = {
                idFlight: flight.idFlight,
                idUserCost: flight.idUserCost,
                costReal: flight.costReal,
                isInvoiced: flight.costReal === 0 ? 0 : 1,
                isClosed: 1,
                voucherStage: flight.idFlightType === 4720 ? 3 : 0,
                idMovement: flight.idFlightType === 4720 ? movement?.idMovement ?? 0 : 0,
            }
            console.log(flightInvoiceUpdated)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/flights/close',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(flightInvoiceUpdated),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                {
                    window.location.hash = 'ops/flights/invoice'
                }
            } else {
                setFlightsInvoice((prevFlights) =>
                    prevFlights.map((f) =>
                        f.idFlight === flight.idFlight
                            ? { ...f, loading: false }
                            : f
                    )
                );
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);

            setFlightsInvoice((prevFlights) =>
                prevFlights.map((f) =>
                    f.idFlight === flight.idFlight
                        ? { ...f, loading: false }
                        : f
                )
            );
        } finally { setLoading(false) }

    }
    const movementOptions = useMemo(() =>
        movements.map((m: ItemsMovement) => ({
            label: `Id Mov ${m.idMovement}`,
            value: m.idMovement.toString(),
            description: m.jsonMovement.nombre,
            labelTag: formatCurrency(m.ammount, "CLP"),
            tags: [`Mov ${m.idMovement}`, `Rec ${m.receipt}`, `Fecha ${m.jsonMovement.dateProgram}`]
        })),
        [movements]);


    const flightsInvoiceFiltered: ItemFlight[] = flightsInvoice.filter((item) => {
        const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.userPilot, item.registration, item.departureDate, item.idFlight.toString(), item.userInstructor, item.flightType].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const colors = data.usersTypes;
    return (
        <CustomAppLayout
            toolsHide

            contentType="form"
            breadcrumbs={
                < BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            splitPanelOpen={!!flightInvoice}

            onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = "ops/flights/invoice" : null}
            splitPanel={!!flightInvoice && (
                <SplitPanel
                    closeBehavior='hide'
                    hidePreferencesButton
                    header={`Facturar vuelo ${flightInvoice.idFlight}`}>
                    <SpaceBetween direction='vertical' size='m'>
                        <FormField label={"Con cargo a:"}>
                            {flightInvoice.idFlightType !== 4720 ?
                                <SpaceBetween direction='vertical' size='m'>
                                    <RadioGroup
                                        onChange={(e) => {
                                            setFlightInvoice({
                                                ...flightInvoice,
                                                idUserCost: Number(e.detail.value)
                                            })
                                            console.log(e.detail.value)
                                            if (e.detail.value !== "0")
                                                setChargeIdUser(0)
                                        }}
                                        items={[
                                            {
                                                label: flightInvoice.userPilot, value: flightInvoice.idUserPilot.toString(), description: "Piloto"
                                            },

                                            ...(flightInvoice.idUserInstructor !== 0 ? [
                                                { label: flightInvoice.userInstructor, value: flightInvoice.idUserInstructor.toString(), description: "Instructor" }
                                            ] : []),
                                            { label: "Otro usuario", value: "0" }

                                        ]}
                                        value={flightInvoice.idUserCost.toString() ?? "0"}
                                    />
                                    <SelectUser value={chargeIdUser}
                                        disabled={flightInvoice.idUserCost !== 0}
                                        onConfirm={(idUser) => {
                                            setChargeIdUser(idUser ? idUser.idUser : 0)
                                            setFlightInvoice({
                                                ...flightInvoice,
                                                idUserCost: 0
                                            })

                                        }}
                                    />
                                </SpaceBetween>
                                :


                                <RadioGroup
                                    onChange={(e) => {

                                    }}
                                    items={[
                                        {
                                            label: getUser(flightInvoice.idUserCost, data).displayName, value: flightInvoice.idUserCost.toString(), description: "Piloto"
                                        },

                                    ]}
                                    value={flightInvoice.idUserCost.toString() ?? "0"}
                                />
                            }

                        </FormField>
                        <HorizontalRule />

                        <FormField label={"A pagar:"}>

                            {flightInvoice.idFlightType !== 4720 ?


                                <SpaceBetween direction='vertical' size='m'>
                                    <RadioGroup
                                        onChange={(e) => {
                                            setFlightInvoice({
                                                ...flightInvoice,
                                                costReal: Number(e.detail.value)
                                            })
                                            if (e.detail.value !== "-1")
                                                setChargeCost(0)
                                        }}
                                        items={[
                                            { label: formatCurrency(flightInvoice.cost, "CLP"), value: flightInvoice.cost.toString() },
                                            { label: "Sin costo", value: "0" },
                                            { label: "Otro", value: "-1" }
                                        ]}
                                        value={flightInvoice.costReal.toString() ?? "0"}
                                    />
                                    <CurrencyInput value={chargeCost}
                                        disabled={flightInvoice.costReal !== -1}
                                        onChange={(value) => {
                                            setChargeCost(value)
                                            setFlightInvoice({
                                                ...flightInvoice,
                                                costReal: Number(-1)
                                            })
                                        }}
                                    />
                                </SpaceBetween>
                                :

                                <Select
                                    disabled={movementOptions.length === 0}
                                    filteringType='auto'

                                    onChange={(e) => {
                                        const selectedValue = e.detail.selectedOption.value;
                                        const selectedLabel = e.detail.selectedOption.label;

                                        // Update single selection state
                                        setMovement({
                                            value: selectedValue,
                                            label: selectedLabel,
                                            idMovement: Number(selectedValue),
                                        });

                                        // Update the specific flight in the list
                                        const value = movements.find(o => o.idMovement === Number(selectedValue)).ammount
                                        setFlightInvoice({
                                            ...flightInvoice,
                                            costReal: value,
                                            idMovement: Number(selectedValue),
                                            isInvoiced: 1,
                                            isClosed: 1
                                        }
                                        );
                                    }}
                                    expandToViewport
                                    options={movementOptions}
                                    selectedOption={
                                        movementOptions.find(o => o.value === flightInvoice?.idMovement?.toString()) || null
                                    }
                                />
                            }
                        </FormField>
                        <Box float="right">
                            <Button disabled={!isValidCost()} onClick={() => {
                                handleInvoice({

                                    ...flightInvoice,
                                    idUserCost: flightInvoice.idUserCost === 0 ? chargeIdUser : flightInvoice.idUserCost,
                                    costReal: flightInvoice.costReal === -1 ? chargeCost : flightInvoice.costReal,
                                })
                            }} variant='primary'  >Facturar</Button>
                        </Box>

                    </SpaceBetween >

                </SplitPanel >
            )}
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />}
                        //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >Facturar vuelos</Header>
                        <TableFlights
                            dateFilter="NONE"
                            flights={flightsInvoice}
                            onSelect={(flight: ItemFlight) => {
                                console.log(flight)
                                window.location.hash = `ops/flights/invoice?id=${flight.idFlight}`
                            }} />
                        {/**
                        <Table
                            //onRowClick={({ detail }) => handleFlightInvoiceClick(detail.item)}
                            stickyHeader
                            variant='embedded'
                            cellVerticalAlign='top'
                            filter={
                                <SpaceBetween direction="horizontal" size="xs">
                                    <TextFilter
                                        filteringPlaceholder='Filtar vuelos'
                                        disabled={flightsInvoiceFiltered.length === 0} filteringText={filteringText} onChange={(e) =>
                                            setFilteringText(e.detail.filteringText)
                                        } />

                                    <Button onClick={() => {
                                        if (window.location.hash.includes("id=")) {
                                            window.location.hash = "ops/flights/invoice"
                                        } else {
                                            refreshInvoice()
                                        }
                                    }} style={{ root: btnIconForm }}><Icon path={mdiRefresh} size={1} /></Button>
                                </SpaceBetween>
                            }
                            columnDefinitions={[
                                {
                                    id: "depDate",
                                    header: "ID/Fecha",
                                    cell: item => (
                                        <FormField
                                            label={<Link onClick={() => window.location.hash = `ops/flights/invoice?id=${item.idFlight}`}>{item.idFlight}</Link>}
                                        >{item.departureDate}</FormField>
                                    ),
                                    width: 100
                                },
                                {
                                    id: 'duration',
                                    header: 'TPO',
                                    cell: (item) => <FormField label={minutesToHHMM2(item.delta ?? 0)}>{minutes2Hours(item.delta)} h</FormField>,
                                    width: 100,
                                },
                                {
                                    id: "idEquipment",
                                    header: "Material",
                                    cell: item => (

                                        <FormField
                                            description={`${item?.altitude && item?.altitude > 0 ? `${item.altitude} M` : ""}`}
                                            label={getBookingType(item.idFlightType, data).bookingType}
                                        >{item.registration}{" "}{item.isClosed === 1 && <Icon path={mdiLock} size={0.7} />}

                                        </FormField>
                                    ),
                                    width: 120
                                },
                                {
                                    id: "idUser",
                                    header: "Tripulación",
                                    cell: item => (

                                        <FormField label={item.userPilot}>

                                            {!!item.idUserInstructor && (
                                                item.userInstructor

                                            )}
                                        </FormField>
                                    )
                                },
                            ]}
                            trackBy="idFlight"
                            items={flightsInvoiceFiltered ?? []}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin vuelos pendientes de facturación</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />
                         */}
                    </SpaceBetween >



                </>
            }
        />
    );
};
